
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Constants } from '@app/constants';
import { AuthenticationService } from '@app/core';
import { FormattedEmail } from '@app/core/helpers';
import { RealTimeEvents } from '@app/core/signalr.events';
import { SignalrService } from '@app/core/signalr.service';
import { Subscription } from 'rxjs';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { ToastService } from './toast/toast.service';

const TYPES: any = {
    'DurationExceeded': 'Duration Exceeded',
    'TFNAbandonExceeded': 'TFN Abandon Exceeded',
    'AbandonExceeded': 'Abandon Exceeded',
    'BelowSalesTargetThreshold': 'Below Sales Target',
    'WaitThresholdExceeded': 'Wait Threshold Exceeded',
    'LongWaitingCallExceeded': 'Long Waiting Call Exceeded'
}

@Injectable({
    providedIn: 'root',
})
export class AlertService implements OnDestroy {
    subscriptions = new Array<Subscription>();
    alertBanner: any = {
        isAgent: true,
        agentNotification: []
    };
    showCloseIcon = false;
    showBannerIcon = false;
    constructor(
        private signalRService: SignalrService,
        private authService: AuthenticationService,
        private httpClient: HttpClient,
        private toast: ToastService
    ) {
        this.subscriptions.push(
            this.signalRService.listen(RealTimeEvents.AlertInstanceSingleNotification).subscribe((x: any) => {
                console.log(`AlertInstanceSingleNotification `, x);
                const user = this.authService.getUser();
                if (FormattedEmail(user.Username, false) == x.identity) {
                    const alerts = [x];
                    this.mergedAlert(alerts);
                    this.alertBanner.isAgent = true;
                }
            })
        );
        this.subscriptions.push(
            this.signalRService.listen(RealTimeEvents.AlertInstanceMultipleNotification).subscribe((x: any) => {
                console.log(`AlertInstanceMultipleNotification `, x);
                const user = this.authService.getUser();
                const username = FormattedEmail(user.Username, false);
                if (x.identity.indexOf(username) != -1) {
                    const alerts = [x];
                    this.mergedAlert(alerts);
                    this.alertBanner.isAgent = true;
                }
            })
        );
        this.subscriptions.push(
            this.signalRService.listen(RealTimeEvents.AlertInstanceCompletedNotification).subscribe((alert: any) => {
                console.log(`AlertInstanceCompletedNotification `, alert);
                const mergedAgentAlertBanner = [...this.alertBanner.agentNotification]
                const index = mergedAgentAlertBanner.findIndex(
                    item => item.id === alert.id
                );

                if (index != -1) {
                    mergedAgentAlertBanner.splice(index, 1);
                    this.alertBanner.agentNotification = mergedAgentAlertBanner;
                }
            })
        );
        const user = this.authService.getUser();
        const isAgent = user?.AssignedApp.includes('ConnectHub');
        this.getAlerts(isAgent);
        this.showCloseIcon = isAgent ? false : true;
        this.showBannerIcon = isAgent ? false : true;
        this.alertBanner.isAgent = true;
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((x) => {
            x.unsubscribe();
        });
    }

    getAlerts(isAgent: boolean) {
        let url = `${Constants.APIS.ALERT.GET_SUPERVISOR_ALERT}`
        if (isAgent) {
            url = `${Constants.APIS.ALERT.GET_AGENT_ALERT}`
        }
        this.httpClient.get(url).subscribe((res: any) => {
            let data = res || [];
            data = data.map((alert: any) => ({
                id: alert.Id,
                type: alert.Severity.toLocaleLowerCase(),
                title: `${alert.Category} ${alert.SubCategory}`,
                message: alert.Description,
                timestamp: moment(new Date(alert.TriggeredAt)).format('YYYY-MM-DD HH:mm:ss A'),
                tag: { label: TYPES[alert.Type] || alert.Type },
                actions: alert.Actions.length ? alert.Actions.map((a: any) => ({ key: a, label: a.substring(0, a.lastIndexOf("d")), removeAlertOnClick: false, style: 'success' })) : [],
                ruleId: alert.RuleId,
                identifier: alert.Identifier
            }));
            this.alertBanner.agentNotification = data;
        });
    }

    private mergedAlert(alerts: Array<any>) {
        const mergedAgentAlertBanner = [...this.alertBanner.agentNotification]
        alerts.forEach((alert) => {
            const exists = mergedAgentAlertBanner.some(
                item => item.id === alert.id
            );
            if (exists) {
                return;
            }
            mergedAgentAlertBanner.splice(0, 0, {
                id: alert.id,
                type: alert.severity.toLocaleLowerCase(),
                title: `${alert.category} ${alert.subCategory}`,
                message: alert.description,
                timestamp: moment(new Date(alert.triggeredAt)).format('YYYY-MM-DD HH:mm:ss A'),
                tag: { label: TYPES[alert.type] },
                actions: alert.actions.length ? alert.actions.map((a: any) => ({ key: a, label: a.substring(0, a.lastIndexOf("d")), removeAlertOnClick: false, style: 'success' })) : [],
                ruleId: alert.ruleId,
                identifier: alert.identifier
            });
            this.alertBanner.agentNotification = mergedAgentAlertBanner;
        })
    }
    public onRemoved(event: any) {

    }

    public onAction(event: any) {
        console.log(event);
        const { action, alert } = event;
        const data: any = { Action: action.key, Id: alert.id, RuleId: alert.ruleId };
        this.httpClient.post(`${Constants.APIS.ALERT.UPDATE_AGENT_ALERT_ACK}`, data).subscribe((res: any) => {
            const mergedAgentAlertBanner = [...this.alertBanner.agentNotification]
            const index = mergedAgentAlertBanner.findIndex(
                item => item.id === alert.id
            );
            if (index != -1) {
                mergedAgentAlertBanner.splice(index, 1);
                this.alertBanner.agentNotification = mergedAgentAlertBanner;
                this.toast.success("Alert was successfully marked as " + data.Action);
            }
        });
    }
    toggleAlertBanner() {
        this.alertBanner.isAgent = !this.alertBanner.isAgent;
    }
    getAlertCount() {
        return this.alertBanner.agentNotification?.length;
    }
    isAnyAlertExist(status: string) {
        const exists = this.alertBanner.agentNotification.some(
            (item: any) => item.identifier === status
        );
        if (exists) {
            return true;
        }
        return false;
    }
}

